import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, nextTick, onMounted, onUpdated, ref } from 'vue';
import { CombinationsConfiguratorFormData } from '@/modules/ConfiguratorCombinations/interfaces/CombinationsInterfaces';

interface Props {
    currentStep: number;
    tableHeaderFields: any[];
    productRowsFormData: CombinationsConfiguratorFormData[];
    productsSelectedForCombination: number[];
    currentStepDescription: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsProductTable',
  props: {
    currentStep: null,
    tableHeaderFields: null,
    productRowsFormData: null,
    productsSelectedForCombination: null,
    currentStepDescription: null
  },
  emits: ["toggleProductSelection", "updatePosition"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'toggleProductSelection', productId: number): void;
    (e: 'updatePosition', payload: { productId: number; fieldPID: string; value: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    currentStep: number;
    tableHeaderFields: any[];
    productRowsFormData: CombinationsConfiguratorFormData[];
    productsSelectedForCombination: number[];
    currentStepDescription: string;
};





const { proxy } = getCurrentInstance()!;

const hasScrollbar = ref(false);
const bodyRef = ref<HTMLElement | null>(null);

function checkScrollbar() {
    const bodyElement = bodyRef.value;
    if (bodyElement) {
        hasScrollbar.value = bodyElement.scrollHeight > bodyElement.clientHeight;
    }
}

onMounted(() => {
    checkScrollbar();
    nextTick(() => {
        checkScrollbar();
    });
});

onUpdated(() => {
    nextTick(() => {
        checkScrollbar();
    });
});

function onToggleProductSelection(productId: number) {
    emit('toggleProductSelection', productId);
}

function onUpdatePosition(productId: number, fieldPID: string, position: number) {
    emit('updatePosition', { productId, fieldPID, value: position });
}

function getTableFields(row: CombinationsConfiguratorFormData) {
    return row.formData.filter((field) =>
        props.tableHeaderFields.some((header) => {
            return header.pid === field.fieldPID && field.segment === 'table';
        }),
    );
}

function isRowSelected(productId: number): boolean {
    return props.productsSelectedForCombination.includes(productId);
}

return { __sfc: true,props, emit, proxy, hasScrollbar, bodyRef, checkScrollbar, onToggleProductSelection, onUpdatePosition, getTableFields, isRowSelected }
}

})